import styled from 'styled-components/macro'
import { theme, ifProp, withProp } from 'styled-tools'

const Ribbon = styled.div`
  position: absolute;
  top: ${ifProp('top', '2.2rem', 'auto')};
  right: ${ifProp('left', 'auto', '-2.2rem')};
  bottom: ${ifProp('top', 'auto', '2.2rem')};
  left: ${ifProp('left', '-2.2rem', 'auto')};
  z-index: 10;
  transform: ${withProp(
    ['left', 'top'],
    (left, top) =>
      `${(left && !top) || (top && !left) ? 'rotate(45deg)' : 'rotate(-45deg)'}`
  )};
  background-color: ${theme('soldOutBannerBackground')};
  text-align: center;
  width: 10rem;
  font-size: 0.8125rem;
  line-height: 1.6rem;
  color: ${theme('soldOutBannerText')};
  text-transform: uppercase;
  font-weight: bold;
`

export { Ribbon }
